











































































































































































import { Component, Mixins, Ref } from "vue-property-decorator";
import { State } from "vuex-class";
import { DataTableHeader } from "vuetify/types/index";
import { SortWarekiDate } from "#/utility/appSort";
import PatientHeader from "@/components/patient/PatientHeader.vue";
import AiReportMixin from "@/mixins/aireport/aiReportMixin";
import AxiosMixin from "@/mixins/axiosMixin";
import FocusingMixin from "@/mixins/focusingMixin";
import DateMixin from "#/mixins/dateMixin";
import BaseReportList from "@/components/patient/BaseReportList.vue";
import { MonthReport } from "#/model/monthreport";
import { COMMON } from "#/const";
import UtilMixin from "@/mixins/utilMixin";
import { AiSetChoice } from "@/views/patient/plan/types";
import AiGenerateButton from "@/components/patient/common/aireport/AiGenerateButton.vue";
import AiGenerateButtonNotAgreement from "@/components/patient/common/aireport/AiGenerateButtonNotAgreement.vue";
import AiGenerateHistoryDialog from "@/components/patient/common/aireport/AiGenerateHistoryDialog.vue";
import * as CONST from "@/components/patient/common/aireport/const";
import * as report from "@/store/modules/patient/types";

@Component({
  components: {
    PatientHeader,
    BaseReportList,
    AiGenerateButton,
    AiGenerateButtonNotAgreement,
    AiGenerateHistoryDialog
  }
})
export default class ReportList extends Mixins(
  AiReportMixin,
  AxiosMixin,
  FocusingMixin,
  UtilMixin,
  DateMixin
) {
  @State(report.name) patientState!: report.PatientState;

  /** 差し戻し */
  private REPORT_REMAND = COMMON.REPORT_STATUS.REMAND;

  @Ref("reportList") private readonly reportList?: BaseReportList;

  @Ref("historyDialog")
  private readonly historyDialog?: AiGenerateHistoryDialog;

  private patientId = 0; //利用者ID
  private items: MonthReport[] = []; //月次報告書
  private paths: string[] = []; //最新の3つのパス

  private commentHeader = {
    text: "コメント",
    value: "remand.comment"
  };

  /** AI自動作成確認ダイアログ開閉 */
  private confirmDialog = false;

  /** AI自動作成報告月 */
  private yearmonth = this.thisMonth();

  /** getter */

  /** テーブルヘッダー */
  private get Headers(): DataTableHeader[] {
    const h: DataTableHeader[] = [
      {
        text: "報告月",
        value: "yearmonth_wareki",
        align: "start",
        width: "120px",
        sort: SortWarekiDate
      },
      {
        text: "担当者",
        value: "staff1.ibow_nickname",
        align: "start",
        width: "120px"
      }
    ];

    if (this.IsAiEnabled) {
      h.push({
        text: "AI自動作成",
        value: "ai_generated_at_wareki",
        align: "start",
        width: "240px",
        sort: SortWarekiDate
      });

      if (this.aiMonthReportConfig.is_use_ai_set === 1) {
        h.push({
          text: "記述タイプ",
          value: "ai_set_name",
          align: "start",
          width: "240px"
        });
      }
    }

    return h;
  }

  /** AI自動作成機能ON/OFF */
  private get IsAiEnabled(): boolean {
    return (
      this.patientState.master.ibow_ai_generate_agreement_status
        .month_report_agreement_status === 2
    );
  }

  /** 別添作成オプション表示フラグ */
  private get ShowBettenOption(): boolean {
    return (
      this.aiMonthReportConfig.add_betten_option == 1 &&
      this.patientState.master.is_ai_month_report_betten_enabled == 1
    );
  }

  public async created() {
    this.patientId = Number(this.$route.params.id);
    // 未提出タブ以外ではタブ変更後の取得処理に任せる
    if (!this.$route.query.reporttab || this.$route.query.reporttab === "0") {
      this.fetchMonthReport({ tab: 0, page: 0 });
    }

    if (this.IsAiEnabled) {
      this.checkAiGenerateHistory(2, this.patientId);
    }
  }

  async mounted() {
    // 「iBow AI自動作成」作成オプションの取得
    this.fetchGenerateOption(this.loginUser.staff_id);

    // リアルタイムアップデート用リスナーを作成
    this.createAiReportListener(
      this.patientId,
      CONST.AI_GENERATE_REPORT_TYPE_MONTHREPORT,
      this.fetchMonthReport
    );
  }

  //新規作成
  private clickNew() {
    this.$router.push(`/patient/${this.patientId}/report/edit/0`);
  }
  //編集
  private clickEdit(item: MonthReport) {
    this.$router.push(`/patient/${this.patientId}/report/edit/${item.id}`);
  }

  //前3回の記録
  private last3TimesMonthReport() {
    this.makePdf(window.base_url + "/api/reportlist/pdf/join", {
      str_pdfs: this.paths
    });
  }

  //月次報告書情報一覧取得
  private fetchMonthReport(obj: { tab: number; page: number }): void {
    this.postJsonCheck(
      window.base_url + "/api/patient/reports/get",
      {
        patient_id: this.patientId,
        tab: obj.tab,
        page: obj.page
      },
      res => {
        if (res.data.items != null) {
          this.paths = res.data.paths;
          this.reportList?.finishLoaded(res.data.items);
          if (obj.page != 0) {
            this.items = this.items.concat(res.data.items);
          } else {
            this.items = res.data.items;
          }
        }
      }
    );
  }

  //差し戻し
  private setRemand(recordItem: { item: MonthReport; comment: string }): void {
    recordItem.item.status = this.REPORT_REMAND;
    recordItem.item.remand.comment = recordItem.comment;
    this.postJsonCheck(
      window.base_url + "/api/patient/report/saveRemand",
      {
        month_report: recordItem.item
      },
      () => {
        this.items = this.items.filter(v => v.id !== recordItem.item.id);
      }
    );
  }

  //PDF
  private pdf(item: MonthReport): void {
    this.makePdf(window.base_url + "/api/patient/report/preview/ids", {
      month_report_ids: [item.id],
      month_reports: [item],
      patient_id: this.patientId
    });
  }

  /** AI自動作成確認 */
  private async aiGenerateConfirm() {
    this.confirmDialog = true;
  }

  /** AI自動作成 */
  private async aiGenerate() {
    this.saveGenerateOption();

    this.postJsonCheck(
      window.base_url + "/api/patient/report/aigenerate-pre",
      {
        patient_id: this.patientId,
        yearmonth: this.yearmonth,
        ai_set_id: this.ibowAiGenerateOption.month_report.ai_set_id,
        is_use_ai_set: this.aiMonthReportConfig.is_use_ai_set
      },
      async res => {
        this.postJsonBackgroundIgnore(
          window.base_url + "/api/patient/report/aigenerate",
          {
            document: res.data.document,
            use_vital:
              this.aiMonthReportConfig.add_vital_option == 1
                ? this.ibowAiGenerateOption.month_report.use_vital
                : this.aiMonthReportConfig.default_vital_option,
            use_observation:
              this.aiMonthReportConfig.add_observation_option == 1
                ? this.ibowAiGenerateOption.month_report.use_observation
                : this.aiMonthReportConfig.default_observation_option,
            use_condition: this.ibowAiGenerateOption.month_report.use_condition,
            use_vn_plan:
              this.aiMonthReportConfig.add_vn_plan_option == 1
                ? this.ibowAiGenerateOption.month_report.use_vn_plan
                : this.aiMonthReportConfig.default_vn_plan_option,
            use_vn_record_fam:
              this.aiMonthReportConfig.add_vn_record_fam_option == 1
                ? this.ibowAiGenerateOption.month_report.use_vn_record_fam
                : this.aiMonthReportConfig.default_vn_record_fam_option,
            use_pre_month_report:
              this.aiMonthReportConfig.add_pre_month_report_option == 1
                ? this.ibowAiGenerateOption.month_report.use_pre_month_report
                : this.aiMonthReportConfig.default_pre_month_report_option,
            generate_betten:
              this.aiMonthReportConfig.add_betten_option == 1
                ? this.ibowAiGenerateOption.month_report.generate_betten
                : this.aiMonthReportConfig.default_betten_option,
            generate_daily_life_rate_div:
              this.aiMonthReportConfig.add_daily_life_rate_div_option == 1
                ? this.ibowAiGenerateOption.month_report
                    .generate_daily_life_rate_div
                : this.aiMonthReportConfig.default_daily_life_rate_div_option,
            generate_dementia_daily_life_rate_div:
              this.aiMonthReportConfig
                .add_dementia_daily_life_rate_div_option == 1
                ? this.ibowAiGenerateOption.month_report
                    .generate_dementia_daily_life_rate_div
                : this.aiMonthReportConfig
                    .default_dementia_daily_life_rate_div_option,
            generate_contents:
              this.aiMonthReportConfig.add_contents_option == 1
                ? this.ibowAiGenerateOption.month_report.generate_contents
                : this.aiMonthReportConfig.default_contents_option,
            generate_adl:
              this.aiMonthReportConfig.add_adl_option == 1
                ? this.ibowAiGenerateOption.month_report.generate_adl
                : this.aiMonthReportConfig.default_adl_option,
            generate_communication:
              this.aiMonthReportConfig.add_communication_option == 1
                ? this.ibowAiGenerateOption.month_report.generate_communication
                : this.aiMonthReportConfig.default_communication_option,
            generate_role_in_the_home:
              this.aiMonthReportConfig.add_role_in_the_home_option == 1
                ? this.ibowAiGenerateOption.month_report
                    .generate_role_in_the_home
                : this.aiMonthReportConfig.default_role_in_the_home_option,
            generate_leisure_activities:
              this.aiMonthReportConfig.add_leisure_activities_option == 1
                ? this.ibowAiGenerateOption.month_report
                    .generate_leisure_activities
                : this.aiMonthReportConfig.default_leisure_activities_option,
            generate_volunteer_activities:
              this.aiMonthReportConfig.add_volunteer_activities_option == 1
                ? this.ibowAiGenerateOption.month_report
                    .generate_volunteer_activities
                : this.aiMonthReportConfig.default_volunteer_activities_option,
            generate_activities_after:
              this.aiMonthReportConfig.add_activities_after_option == 1
                ? this.ibowAiGenerateOption.month_report
                    .generate_activities_after
                : this.aiMonthReportConfig.default_activities_after_option,
            ai_set_id: this.ibowAiGenerateOption.month_report.ai_set_id,
            is_use_ai_set: this.aiMonthReportConfig.is_use_ai_set
          },
          () => {
            //
          }
        );
        this.confirmDialog = false;
        this.$openAlert(
          "作成を開始しました。AI自動作成の結果はチャットで通知します。また、[AI自動作成]ボタンの[履歴をみる]でも状況を確認できます。"
        );
      }
    );
  }

  /** AI自動作成履歴をみる */
  private openHistory() {
    this.historyDialog?.open();
  }

  /** AIセット選択時 */
  private changeAiSet(aiSet: AiSetChoice) {
    if (!aiSet.is_valid) {
      return;
    }
    this.ibowAiGenerateOption.month_report.ai_set_id = aiSet.id;
  }
}
